import { useMemo } from 'react';

import { useGetMotorLovs } from '@features/production/proposal/proposal.slice';
import { lookupListAsRecordObject } from '@utils/graph-utils';

export const useAmendmentMotorLovs = () => {
  const { data, loading, error } = useGetMotorLovs();

  const motorLovs = useMemo(() => {
    if (!data?.core) {
      return {
        plateCodeList: {},
        usageTypeList: {},
        bodyTypeList: {},
        engineTypeList: {},
        makeList: {},
        modelList: {},
        colorList: {}
      };
    }

    return {
      plateCodeList: lookupListAsRecordObject(data.core.getPlateCodeList ?? []),
      usageTypeList: lookupListAsRecordObject(data.core.getUsageTypeList ?? []),
      bodyTypeList: lookupListAsRecordObject(data.core.getBodyTypeList ?? []),
      engineTypeList: lookupListAsRecordObject(
        data.core.getEngineTypeList ?? []
      ),
      makeList: lookupListAsRecordObject(data.core.getMakeList ?? []),
      modelList: {},
      colorList: lookupListAsRecordObject(data.core.getColorList ?? [])
    };
  }, [data]);

  return { motorLovs, loading, error };
};
